import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Menu } from '@mui/icons-material'
import { Avatar, Button, Link } from '@mui/material'
import { MdShoppingCart } from 'react-icons/md'

import { Flex } from '@/ui'
import { ChooseLanguage } from './ChooseLanguage'
import { useRouter } from '@/hooks/router'

import { useThemeStore } from '@/stores/app/theme'
import { useUserStore } from '@/stores/app/user'
import { useOrderCreateStore } from '@/stores/orders/create'
import { joinStyles } from '@/utils/app/theme'
import { ID_MANAGER_FREEGO, urls } from '@/utils/constants'

import * as styles from './index.css'

export const Header = () => {
    const router = useRouter()
    const { t } = useTranslation()

    const logo = useThemeStore((state) => state.logo)
    const hasOrder = useThemeStore((state) => state.hasOrder)
    const user = useUserStore((state) => state.user)
    const firstName = useUserStore((state) => state.user.firstName)

    const articles = useOrderCreateStore((state) => state.articles)

    const [wantsNavigate, setWantsNavigate] = useState(false)

    const totalNumberArticles = articles.reduce(
        (total, article) =>
            total + (article.is_weight_quantity ? 1 : article.quantity),
        0,
    )

    const links = [
        ...(user.id > -1
            ? [
                  // TODO: Use a dynamic variable
                  ...(user.client === ID_MANAGER_FREEGO
                      ? []
                      : [
                            {
                                name: t('refill'),
                                url: urls.REFILL,
                            },
                        ]),
                  {
                      name: t('refills'),
                      url: urls.REFILLS,
                  },
                  ...(user.site_customer > -1
                      ? [
                            {
                                name: t('stocks'),
                                url: urls.STOCKS,
                            },
                        ]
                      : []),
                  {
                      name: t('disputes'),
                      url: urls.DISPUTES,
                  },
              ]
            : []),
        ...(hasOrder
            ? [
                  {
                      name: t('orders'),
                      url: urls.orders.LIST,
                  },
                  {
                      name: t('products'),
                      url: urls.catalogue.products.LIST,
                  },
              ]
            : []),
    ]

    return (
        <header className={styles.root}>
            <Flex className={styles.header}>
                {/* Homepage button */}
                <Link
                    className={styles.homepage}
                    variant='button'
                    onClick={() => {
                        if (user.id === -1) {
                            return
                        }

                        setWantsNavigate(false)
                        router.push(urls.HOMEPAGE)
                    }}
                >
                    <img
                        className={styles.logo}
                        src={logo}
                        alt='Client Logo'
                    />
                </Link>

                <Flex>
                    {/* Cart displayed on mobile */}
                    {!!hasOrder && (
                        <Button
                            className={joinStyles(
                                styles.cartButton,
                                styles.cartMobile,
                            )}
                            variant='outlined'
                            onClick={() => {
                                setWantsNavigate(false)
                                router.push(urls.CART)
                            }}
                        >
                            <MdShoppingCart />

                            {totalNumberArticles > 0 && (
                                <div className={styles.cartQuantity}>
                                    {totalNumberArticles}
                                </div>
                            )}
                        </Button>
                    )}

                    {/* Show navigation bar (for mobile) */}
                    <Button
                        className={styles.menu}
                        onClick={() => {
                            setWantsNavigate(!wantsNavigate)
                        }}
                    >
                        <Menu />
                    </Button>
                </Flex>

                {/* Links available */}
                <Flex className={styles.group}>
                    {links.map((link) => (
                        <Button
                            key={link.url}
                            className={styles.link}
                            onClick={() => {
                                router.push(link.url)
                            }}
                        >
                            {link.name}
                        </Button>
                    ))}
                </Flex>

                {/* Settings */}
                <Flex className={styles.group}>
                    {/* Language */}
                    <ChooseLanguage setWantsNavigate={setWantsNavigate} />

                    {/* Account */}
                    {user.id !== -1 && (
                        <Button
                            className={styles.setting}
                            variant='outlined'
                            onClick={() => router.push(urls.ACCOUNT)}
                        >
                            <Avatar
                                className={styles.avatar}
                                src={undefined}
                            />

                            <div className={styles.name}>{firstName}</div>
                        </Button>
                    )}

                    {/* Cart button */}
                    {!!hasOrder && (
                        <Button
                            className={styles.cartButton}
                            variant='outlined'
                            onClick={() => {
                                setWantsNavigate(false)
                                router.push(urls.CART)
                            }}
                        >
                            <MdShoppingCart />

                            <div className={styles.cartQuantity}>
                                {totalNumberArticles}
                            </div>
                        </Button>
                    )}
                </Flex>
            </Flex>

            {!!wantsNavigate && (
                <div>
                    {/* Links available */}
                    {links.map((link) => (
                        <div key={link.url}>
                            <Button
                                className={joinStyles(
                                    styles.link,
                                    styles.linkNavigation,
                                )}
                                onClick={() => {
                                    setWantsNavigate(false)
                                    router.push(link.url)
                                }}
                            >
                                {link.name}
                            </Button>
                        </div>
                    ))}

                    <Flex className={styles.settingsNavigation}>
                        {/* Language */}
                        <ChooseLanguage setWantsNavigate={setWantsNavigate} />

                        {/* Account */}
                        {user.id !== -1 && (
                            <Button
                                className={styles.setting}
                                variant='outlined'
                                onClick={() => {
                                    setWantsNavigate(false)
                                    router.push(urls.ACCOUNT)
                                }}
                            >
                                <Avatar
                                    className={styles.avatar}
                                    src={undefined}
                                />

                                <div className={styles.name}>{firstName}</div>
                            </Button>
                        )}
                    </Flex>
                </div>
            )}
        </header>
    )
}
